import { Box } from "@mui/material";
import React, { useEffect, useState } from "react";
import TextSaveInput from "../../input/text-save-input";
import TextInput from "../../input/text-input";

const Text1Widget = ({ widget, onValueUpdate }) => {
  const [v0, setV0] = useState(null);

  useEffect(() => {
    setV0(widget);
    return () => {};
  }, [widget]);

  const handleValueUpdate = (data) => {
    const updatedWidget = { ...v0, value: data.toString() };
    onValueUpdate(updatedWidget);
  };

  return (
    <Box
      sx={{
        display: "flex",
        alignItems: "center",
        height: "100%",
        width: "100%",
        padding: "2px",
      }}
    >
      {v0 && (
        <TextInput
          valueSpec={v0}
          onChange={handleValueUpdate}
          style="compact"
        />
      )}
    </Box>
  );
};

export default Text1Widget;
